import { CustomObserverService } from './../../../shared/services/custom-observable.service';
import { defaultLanguage } from './../../constant';
import { CommonService } from './../../../shared/services/common-service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieManagerService, HttpClientService, ShoppingCartService } from '../../../shared/';
import { TranslateService } from '@ngx-translate/core';
import { CookieNames, BasicRoutes, ApiEndpoints, Testomonials, Info } from '../../constant';
import { PaperSet, OnlinePaper } from '../../model';
import { NgxCarousel } from 'ngx-carousel';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { StripHtmlPipe } from '../../../stripHtml';

declare var $: any;
@Component({
  selector: 'app-landing',
  templateUrl: '../views/landing.component.html',
  styleUrls: ['../views/landing.component.css']
})
export class LandingComponent implements OnInit {


  public defoltLanguage: string = 'tm';
  public popularPaperSets: Array<PaperSet> = [];
  public paperSetType = "PAPERS";
  public wijayanews;
  public carouselOne: NgxCarousel;
  public carouselTwo: NgxCarousel;
  public carouselWijaya: NgxCarousel;
  public testomonials = [
    {
      image: '/assets/img/version_2/comment-4.svg',
    },
    {
      image: '/assets/img/version_2/comment-3.svg',
    },
    {
      image: '/assets/img/version_2/comment-5.svg',
    },
    {
      image: '/assets/img/version_2/comment-2.svg',
    }];


  public testomonialsVidoes: any;
  public mobile: string = Info.mobile;
  public mail: string = Info.mail;
  public hotline: any;
  public aboutUs: any;
  constructor(
    private striphtml: StripHtmlPipe,
    private cookieManagerService: CookieManagerService,
    private shoppingCartService: ShoppingCartService,
    private httpClientService: HttpClientService,
    private translateService: TranslateService,
    private customObserverService: CustomObserverService,
    private router: Router,
    private commonService: CommonService,
    private sanitizer: DomSanitizer
  ) {
    // scroll down
    $(function () {
      $('.scroll-down').click(function () {
        $('html, body').animate({ scrollTop: $('section.ok').offset().top }, 'slow');
        return false;
      });
    });
  }

  ngOnInit() {

    this.testomonialsVidoes = [
      {
        videoUrl: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/5vkaXP1JQmI?rel=0'),
      },
      {
        videoUrl: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/4dO1WRuOnJI?rel=0'),
      },
      {
        videoUrl: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/OdgpmBZvJxU?rel=0'),
      },
      {
        videoUrl: this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/Wxm9KxxXr4g?rel=0')
      }];

    if (this.cookieManagerService.getCookie(CookieNames.loginKey, false)) {
      this.router.navigate([BasicRoutes.clientExams]);
    }
    // this.getPopularPaperSet();
    var language = this.cookieManagerService.getCookie("Lang", false);
    this.translateService.use(language ? language : defaultLanguage);
    this.customObserverService.setCurrentPaymentType(language);

    this.carouselOne = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 300,
      interval: 2000,
      point: {
        visible: true
      },
      load: 1,
      touch: true,
      custom: 'banner',
    }

    this.carouselWijaya = {
      grid: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 },
      slide: 1,
      speed: 400,
      interval: 3000,
      point: {
        visible: true
      },
      loop: true
    }
    this.getPartners();

    this.getWijayaNews();
  }

  getPopularPaperSet() {
    this.httpClientService.authGet(ApiEndpoints.popularPaperSets, null).subscribe(response => {
      response.forEach(set => {
        this.popularPaperSets.push(new PaperSet(set));
      });
      (this.popularPaperSets.length && this.popularPaperSets[1].brandImage) ? null : this.removeShakeSponserImage();
    }, error => {

    });
  }

  getPartners() {
    this.commonService.getPartners().then((response: any) => {
      this.aboutUs = response;
      this.hotline = this.aboutUs ? this.aboutUs.contact : null;

    });
  }


  getWijayaNews() {
    // this.commonService.getwijayanews().then((response: any) => {
    //   console.log(response);
    //   //
    //   this.wijayanews = response;

    // });
  }




  removeShakeSponserImage() {
    $('#shake-spons-img').removeClass('shake-spons');
  }

  morePapers() {
    this.router.navigate([BasicRoutes.clientExams]);
  }

  openCart() {
    this.shoppingCartService.resetTimer();
  }





}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/login/components/landing.component.ts